<template>
  <div id="app">
    <LayoutComponent>
   
      <router-view />
    </LayoutComponent>
  </div>
</template>

<script setup>
import {  provide } from "vue";
import { useToast } from 'vue-toastification'

import LayoutComponent from "@/components/ui/LayoutComponent.vue";

const toast = useToast()




provide('toast', toast)

provide('showNotification', (type, title, message) => {
  toast[type](message, { timeout: 3000, rtl: true })
})

</script>

<style>
</style>